export default __webpack_public_path__ + "static/button-text-only-f4b0d88ce3e316d61d42534540639110.png";